export enum RoutingConfigTypeEnum {
  INBOX="INBOX",
  OUTBOX="OUTBOX"
}
